import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import RolesTable from "./RolesTable";
import RolesHeader from "./RolesHeader";
import RolesDrawer from "./RolesDrawer";
import RolesDeleteRoleModal from "./RolesDeleteRoleModal";
import RolesEditRoleModal from "./RolesEditRoleForm";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const RolesPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["roles"] -- the same declaration Layout.tsx's
  // sidebar link reads.
  const allowed = useScreenPermission("roles");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <RolesHeader />
          <RolesTable />
          <RolesDrawer />
          <RolesDeleteRoleModal />
          <RolesEditRoleModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default RolesPage;
